module.exports = __webpack_public_path__ + "img/posture_perfect6.4c8ca4e6.png";